import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAPmTSCcsvgxYTmRSHIK4l96HI5m0-ahvQ",
  authDomain: "mealcycle-4c004.firebaseapp.com",
  projectId: "mealcycle-4c004",
  storageBucket: "mealcycle-4c004.firebasestorage.app",
  messagingSenderId: "1076691975230",
  appId: "1:1076691975230:web:c16a90893eb3999af8a56f",
  measurementId: "G-NL1V2Q3KY5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);

// ✅ CORRECCIÓN: Nueva API de Firestore para persistencia offline (Sin warnings)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({tabManager: persistentMultipleTabManager()})
});

export const storage = getStorage(app); 
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();

// Configure Google Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;